/**
 * Generic CSV download utility.
 * Accepts an array of plain objects; the keys of the first object
 * become the column headers.  All values are safely escaped.
 */
export function downloadCsv(
  filename: string,
  rows: Record<string, string | number | null | undefined>[],
): void {
  if (!rows.length) return;

  const escape = (v: string | number | null | undefined): string => {
    const s = v === null || v === undefined ? '' : String(v);
    // Wrap in quotes when the value contains a comma, newline, or quote
    if (s.includes(',') || s.includes('\n') || s.includes('"')) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };

  const headers = Object.keys(rows[0]);
  const lines = [
    headers.map(escape).join(','),
    ...rows.map((row) => headers.map((h) => escape(row[h])).join(',')),
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
